/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import './init'

import './components/shared/ErrorProfile'
import './components/shared/FormInput'
import './components/shared/FormLabel'
import './components/shared/Header'

import './components/userEdit/Avatar'
import './components/userEdit/ConnectedServices/index'
import './components/userEdit/PasswordChange'
import './components/userEdit/UserIdentity'
import './components/userEdit/UserSettingsForm'
import './components/userEdit/UserEditContainer'

import './components/report/CodeView'
import './containers/pull_request/Header/index'
import './containers/project_dashboard/Header/index'
import './components/project_dashboard/PRList/index'
import './components/project_dashboard/PRList/PRListItem/index'



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js